"use client";

import React from "react";
import { MapPin, CircleCheck, Globe } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
const projectHubs = [{
  id: "hub-1",
  x: 68,
  y: 38,
  title: "Silk Road Cultural Heritage Park",
  location: "Xi'an, China",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/xian_cultural_heritage_park.png",
  scope: "Master Planning, Architectural Design, Investment Advisory"
}, {
  id: "hub-2",
  x: 52,
  y: 45,
  title: "Oasis Integrated Resort",
  location: "Dubai, UAE",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/dubai_oasis_integrated_resort.png",
  scope: "Engineering, Procurement, Construction Management"
}, {
  id: "hub-3",
  x: 48,
  y: 32,
  title: "Eurasian Theme Destination",
  location: "Istanbul, Turkey",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/istanbul_eurasian_theme_destination.png",
  scope: "Concept Design, Ride Procurement, Operations Setup"
}, {
  id: "hub-4",
  x: 75,
  y: 55,
  title: "Tropical Eco-Tourism Zone",
  location: "Bali, Indonesia",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/bali_tropical_eco_tourism_zone.png",
  scope: "Sustainable Engineering, Landscape Design, Turnkey Construction"
}, {
  id: "hub-5",
  x: 35,
  y: 28,
  title: "Historic Port Revitalization",
  location: "Athens, Greece",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/athens_historic_port_revitalization.png",
  scope: "Urban Planning, Cultural Integration, Project Management"
}];
export default function GlobalFootprintImpact() {
  return <section id="global-footprint-impact" className="dark bg-background text-foreground relative w-full overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[500px] opacity-20 pointer-events-none">
        <div className="absolute inset-0 bg-primary/30 blur-[120px] rounded-full mix-blend-screen"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16 lg:mb-24">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6 border border-primary/20">
            <Globe className="w-4 h-4" />
            <span>Belt and Road Initiative Focus</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold tracking-tight mb-6 text-foreground">
            Global Footprint & Impact
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed">
            Delivering integrated EPCO solutions across international markets. From visionary planning to operational excellence, AOTO transforms cultural landscapes into world-class tourism destinations.
          </p>
        </div>

        {}
        <div className="relative w-full max-w-6xl mx-auto aspect-[4/3] md:aspect-[2/1] lg:aspect-[2.5/1] bg-card/40 rounded-3xl border border-border overflow-hidden backdrop-blur-md shadow-2xl shadow-black/50">
          
          {}
          <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1581784/img/stylized_silk_road_map_dark.png)] bg-cover bg-center opacity-60 mix-blend-luminosity"></div>
          
          {}
          <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:3rem_3rem]"></div>

          {}
          {projectHubs.map((hub, index) => <div key={hub.id} data-index={index} className="absolute transform -translate-x-1/2 -translate-y-1/2 z-20" style={{
          left: `${hub.x}%`,
          top: `${hub.y}%`
        }}>
              <Dialog>
                <DialogTrigger asChild>
                  <button className="relative group flex items-center justify-center w-10 h-10 focus:outline-none cursor-pointer">
                    {}
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-30"></span>
                    {}
                    <span className="relative inline-flex h-3.5 w-3.5 rounded-full bg-primary shadow-[0_0_15px_rgba(234,179,8,0.6)] group-hover:scale-150 transition-transform duration-300 border border-background"></span>
                    
                    {}
                    <span className="absolute top-full mt-2 left-1/2 -translate-x-1/2 px-2 py-1 bg-popover text-popover-foreground text-xs font-medium rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap border border-border shadow-lg hidden md:block">
                      {hub.location}
                    </span>
                  </button>
                </DialogTrigger>
                
                <DialogContent className="sm:max-w-[600px] p-0 overflow-hidden border-border bg-card shadow-2xl shadow-black/80">
                  <DialogHeader className="sr-only">
                    <DialogTitle>{hub.title}</DialogTitle>
                    <DialogDescription>Project details for {hub.location}</DialogDescription>
                  </DialogHeader>
                  
                  {}
                  <div className="relative h-64 sm:h-72 w-full bg-muted">
                    <img src={hub.image} alt={hub.title} className="object-cover w-full h-full" />
                    <div className="absolute inset-0 bg-gradient-to-t from-card via-card/40 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <h3 className="text-2xl sm:text-3xl font-serif font-bold text-foreground mb-2 leading-tight">
                        {hub.title}
                      </h3>
                      <div className="flex items-center gap-2 text-primary text-sm font-medium">
                        <MapPin className="w-4 h-4" />
                        {hub.location}
                      </div>
                    </div>
                  </div>
                  
                  {}
                  <div className="p-6 pt-4 bg-card">
                    <h4 className="text-xs font-bold text-muted-foreground uppercase tracking-widest mb-4 flex items-center gap-2">
                      <span className="w-4 h-[1px] bg-primary"></span>
                      Integrated EPCO Scope
                    </h4>
                    <ul className="space-y-3">
                      {hub.scope.split(', ').map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3 text-sm sm:text-base text-card-foreground">
                          <CircleCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                          <span className="leading-relaxed">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </DialogContent>
              </Dialog>
            </div>)}
        </div>
        
        {}
        <div className="mt-8 flex justify-center items-center gap-4 text-sm text-muted-foreground">
          <div className="flex items-center gap-2">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-40"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-primary"></span>
            </span>
            <span>Key Project Hubs</span>
          </div>
        </div>
      </div>
    </section>;
}